import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";  // Initialize i18n
import App from "@/App";
import { readTrafficSource } from "@/lib/formSession";

// Capture a partner's tagged link BEFORE the first render, not only in the root effect. The effect
// runs after the page has drawn, so a visitor (or a redirect) that leaves the landing URL quickly
// could take the tags with it, and the lead would arrive untagged: an Importify referral Importify
// never hears about. Reading the URL here is synchronous and costs nothing.
readTrafficSource();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
